import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css';
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import 'swiper/swiper-bundle.css';

import './market_projects.css';

const MarketProjects = () => {

    const sectionScrollHandler = (sectionId) => {
        const section = document.getElementById(sectionId);

        if (section) {
            window.scrollTo({
                top: section.offsetTop,
                behavior: "smooth"
            });
        }
    };

    const settings = {
        spaceBetween: 30,
        loop: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: true,
        },
        navigation: true,
        pagination: {
            clickable: true,
        },
        breakpoints: {
            450: {
                slidesPerView: 1,
                slidesPerGroup: 1
            },
            1200: {
                slidesPerView: 3,
                slidesPerGroup: 1
            }
        },
    };

    return (
        <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            {...settings}
        >
            <SwiperSlide>
                <div className='card' onClick={() => sectionScrollHandler("form_section")}>
                    <div id='card_img_div'>
                        <img id='images' src='' alt="image" />
                    </div>
                    <div id='card_hdng_div'>
                        <h5 id='card_hdng'>
                            Property Management Software
                        </h5>
                    </div>
                    <div id='card_txt_div'>
                        <p id='card_text'>
                            Streamline and automate your property management operations with our advanced software solutions tailored to your unique needs.
                        </p>
                    </div>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className='card' onClick={() => sectionScrollHandler("form_section")}>
                    <div id='card_img_div'>
                        <img id='images' src='' alt="image" />
                    </div>
                    <div id='card_hdng_div'>
                        <h5 id='card_hdng'>
                            CRM Process Implementation
                        </h5>
                    </div>
                    <div>
                        <p id='card_text'>
                            Maximize customer relationships and boost sales with our CRM process implementation services designed specifically for the real estate sector.
                        </p>
                    </div>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className='card' onClick={() => sectionScrollHandler("form_section")}>
                    <div id='card_img_div'>
                        <img id='images' src='' alt="image" />
                    </div>
                    <div id='card_hdng_div'>
                        <h5 id='card_hdng'>
                            3D Visualization Services (AR/VR)
                        </h5>
                    </div>
                    <div>
                        <p id='card_text'>
                            Bring properties to life with immersive 3D visualization services using augmented reality (AR) and virtual reality (VR) technologies.
                        </p>
                    </div>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className='card' onClick={() => sectionScrollHandler("form_section")}>
                    <div id='card_img_div'>
                        <img id='images' src='' alt="image" />
                    </div>
                    <div id='card_hdng_div'>
                        <h5 id='card_hdng'>
                            SEO (Search Engine Optimization)
                        </h5>
                    </div>
                    <div>
                        <p id='card_text'>
                            Enhance your online visibility and drive organic traffic to your real estate business with our proven SEO strategies.
                        </p>
                    </div>
                </div>
            </SwiperSlide>
            {/* Repeat for other items */}
        </Swiper>
    );
};

export default MarketProjects;

